


























































import { Component } from "vue-property-decorator";
import Swiper from "@/components/Swiper.vue";
import ScrollPanel from "@/components/ScrollPanel.vue";
import Zan from "@/components/Zan.vue";
import Header from "@/components/Header.vue";
import request from "@/api/index";
import { ILiveItem, ILiveTextItem } from "@/api/types.d";
import { List, PullRefresh } from "vant";
import { wxChatShare } from "@/common/wechat";
import Base from "@/template/public/Base.vue";
import native from "@/common/Native";
import AppPrompt from "@/components/AppPrompt.vue";
import { findNameByWechatAppid } from "@/common/Utils";
@Component({
  components: {
    Swiper,
    ScrollPanel,
    VanList: List,
    VanPullRefresh: PullRefresh,
    Zan,
    Header,
    AppPrompt
  },
  filters: {
    showTime(time: string) {
      if (time) {
        const hour = new Date(time.replace(/-/g, "/")).getHours();
        const minute = new Date(time.replace(/-/g, "/")).getMinutes();
        return (
          (hour < 10 ? "0" + hour : hour) +
          ":" +
          (minute < 10 ? "0" + minute : minute)
        );
      }
      return "";
    }
  }
})
export default class NewsRelease extends Base {
  private circularList: ILiveItem[] = [];
  private normalList: ILiveItem[] = [];
  private textList: ILiveTextItem[] = [];
  private newsInfo: object = {};
  private informationId: number = 0;
  private infoClassifyid: string = "";
  private lastSort: number | undefined;
  private lastTime: string | undefined;
  private lastId: number | undefined;
  private loading: boolean = false;
  private finished: boolean = false;
  private isLoading: boolean = false;
  public request = new request();
  public appId: string = "";
  public info: any = {};
  wxAppId = "";
  created() {
    this.$route.meta.keepAlive = true;
    this.infoClassifyid = this.$route.query.cid as string;
    this.appId = (this.$route.query.appId as string) || "";
    this.$store.commit("SET_STATE", {
      appId: this.appId
    });
    this.liveDetail().then(() => {
      this.getShareInfo(this.appId);
      this.liveText();
    });
    this.addViewCount();
    this.share();
    this.getCount();
    this.wxAppId = findNameByWechatAppid(this.$store.state.appInfo, this.appId);
  }

  share() {
    this.request.getBusinessDetail(this.infoClassifyid, "1").then(result => {
      const info = result.data;
      wxChatShare(
        info.detailTitle,
        info.shareDescription,
        info.shareUrlWx,
        info.shareImgUrl
      );
    });
  }

  getCount() {
    if (!native.isOpenInApp()) {
      // 在app外才需要增加浏览量
      this.request.getCount(this.appId, this.infoClassifyid);
    }
  }

  liveDetail() {
    return this.request.liveDetail(this.infoClassifyid).then(result => {
      if (result.code === 0) {
        this.newsInfo = result.data;
        this.informationId = result.data.infoId;
        this.circularList = result.data.circular.map(item => {
          item.title = item.spokesman;
          return item;
        });
        this.normalList = result.data.normal.map(item => {
          item.title = item.spokesman;
          return item;
        });
      }
      this.isLoading = false;
    });
  }

  addViewCount() {
    this.request.increaseViewCount(this.infoClassifyid, "1");
  }

  liveText(isClear = true) {
    if (!this.informationId) {
      return;
    }
    this.request
      .liveText(this.informationId, this.lastSort, this.lastTime, this.lastId)
      .then(result => {
        if (isClear) {
          this.textList = [];
        }
        if (result.data.length === 0) {
          this.finished = true;
        } else {
          this.isLoading = false;
          this.loading = false;
          this.textList = this.textList.concat(result.data);
          this.lastId = result.data.lastChild.id;
          this.lastSort = result.data.lastChild.sortNo;
          this.lastTime = result.data.lastChild.onlineTime;
        }
      });
  }
  onLoad() {
    this.liveText(false);
  }
  onRefresh() {
    this.lastSort = undefined;
    this.lastId = undefined;
    this.lastTime = undefined;
    this.textList = [];
    this.finished = false;
    this.liveDetail().then(() => {
      this.liveText();
    });
  }
  itemClick(item: ILiveItem) {}
}
